import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import * as React from 'react';
import Animated from "react-native-web/dist/exports/Animated";
import Easing from "react-native-web/dist/exports/Easing";
import Platform from "react-native-web/dist/exports/Platform";
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import * as SVG from 'react-native-svg';
import { useActive, useHover } from 'react-native-web-hooks';
import { TouchableOpacity } from "./Elements";
var width = 70;
var circleWidth = 27;
var sideOffset = 5;
var transitionTime = 200;
export default function Switch(_ref) {
  var onChange = _ref.onChange,
      style = _ref.style,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["onChange", "style", "value"]);

  var onValueChange = React.useMemo(function () {
    return function () {
      return onChange(!value);
    };
  }, [onChange]);
  return React.createElement(TouchableOpacity, _extends({
    accessibilityRole: "button",
    tabIndex: 0,
    activeOpacity: 1.0
  }, props, onEnterAndClick(onValueChange), {
    style: [styles.wrapper, style]
  }), React.createElement(DayNightSwitch, {
    isClicked: value
  }));
}

var createAnimatedValue = function createAnimatedValue(isOn) {
  return React.useRef(new Animated.Value(isOn ? 1 : 0));
};

var MoonIcon = function MoonIcon(_ref2) {
  var isClicked = _ref2.isClicked,
      props = _objectWithoutProperties(_ref2, ["isClicked"]);

  var value = createAnimatedValue(isClicked);
  React.useEffect(function () {
    Animated.timing(value.current, {
      toValue: isClicked ? 1 : 0,
      duration: transitionTime,
      easing: Easing.inOut(Easing.linear)
    }).start();
  }, [isClicked]);
  return React.createElement(Animated.View, {
    style: [styles.moonSvg, {
      opacity: value.current,
      transform: [{
        translateY: value.current.interpolate({
          inputRange: [0, 1],
          outputRange: [30, 0]
        })
      }]
    }, props.style]
  }, React.createElement(SVG.Svg, _extends({
    pointerEvents: "none"
  }, props, {
    style: [styles.moonSvg, props.style],
    viewBox: "0 0 30 32"
  }), React.createElement(SVG.Path, {
    fill: "white",
    d: "M22.592 21.504q3.36 0 6.56-1.792-1.344 4.64-5.184 7.616t-8.8 2.976q-6.016 0-10.304-4.288t-4.288-10.336q0-4.928 2.976-8.768t7.584-5.216q-1.792 3.2-1.792 6.56 0 5.504 3.904 9.376t9.344 3.872z"
  })));
};

var onEnterAndClick = function onEnterAndClick(cb) {
  return {
    onPress: cb,
    onKeyPress: function onKeyPress(e) {
      if (e.which === 13 || e.which === 32) {
        cb && cb(e);
      }
    }
  };
};

var DayNightSwitch = function DayNightSwitch(_ref3) {
  var isClicked = _ref3.isClicked;
  var ref = React.useRef(null);
  var isHovered = useHover(ref);
  var isActive = useActive(ref);
  var value = createAnimatedValue(isClicked);
  var scaleValue = React.useRef(new Animated.Value(1));
  React.useEffect(function () {
    Animated.timing(value.current, {
      toValue: isClicked ? 1 : 0,
      duration: transitionTime
    }).start();
  }, [isHovered, isClicked]);
  React.useEffect(function () {
    Animated.timing(scaleValue.current, {
      toValue: isActive ? 1.03 : isHovered ? 1.05 : 1,
      duration: transitionTime
    }).start();
  }, [isActive, isHovered]);
  var backgroundColor = isHovered ? isClicked ? '#5559cc' : '#79bfc3' : value.current.interpolate({
    inputRange: [0, 1],
    outputRange: ['#80c7cb', '#595dde']
  });
  return React.createElement(Animated.View, {
    ref: ref,
    style: [styles.dayNightSwitch, {
      backgroundColor: backgroundColor,
      transform: [{
        scale: scaleValue.current
      }]
    }]
  }, React.createElement(Stars, {
    isClicked: isClicked
  }), React.createElement(Circle, {
    isClicked: isClicked
  }));
};

var Star = function Star(_ref4) {
  var _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 3 : _ref4$size,
      x = _ref4.x,
      y = _ref4.y,
      index = _ref4.index,
      isClicked = _ref4.isClicked,
      props = _objectWithoutProperties(_ref4, ["size", "x", "y", "index", "isClicked"]);

  var value = createAnimatedValue(isClicked);
  React.useEffect(function () {
    Animated.timing(value.current, {
      toValue: isClicked ? 1 : 0,
      duration: 50 * index
    }).start();
  }, [isClicked]);
  return React.createElement(Animated.View, _extends({}, props, {
    style: [styles.star, {
      width: size,
      height: size,
      top: 8 + y,
      left: 8 + x,
      opacity: value.current,
      transform: [{
        translateY: value.current.interpolate({
          inputRange: [0, 1],
          outputRange: [10, 0]
        })
      }]
    }, props.style]
  }));
};

var Stars = function Stars(_ref5) {
  var isClicked = _ref5.isClicked,
      props = _objectWithoutProperties(_ref5, ["isClicked"]);

  var value = createAnimatedValue(isClicked);
  React.useEffect(function () {
    Animated.timing(value.current, {
      toValue: isClicked ? 1 : 0,
      duration: transitionTime
    }).start();
  }, [isClicked]);
  return React.createElement(Animated.View, _extends({}, props, {
    style: [{
      transform: [{
        translateY: circleWidth * -0.75
      }],
      opacity: value.current
    }, props.style]
  }), props.children, React.createElement(Star, {
    isClicked: isClicked,
    index: 1,
    size: 2,
    x: 10,
    y: 3
  }), React.createElement(Star, {
    isClicked: isClicked,
    index: 2,
    size: 1,
    x: 3,
    y: 7
  }), React.createElement(Star, {
    isClicked: isClicked,
    index: 3,
    size: 1,
    x: 12,
    y: 18
  }), React.createElement(Star, {
    isClicked: isClicked,
    index: 4,
    size: 1,
    x: 15,
    y: 10
  }), React.createElement(Star, {
    isClicked: isClicked,
    index: 5,
    size: 1,
    x: 19,
    y: 4
  }), React.createElement(Star, {
    isClicked: isClicked,
    index: 6,
    size: 2,
    x: 22,
    y: 14
  }));
};

var Circle = function Circle(_ref6) {
  var isClicked = _ref6.isClicked,
      props = _objectWithoutProperties(_ref6, ["isClicked"]);

  var ref = React.useRef(null);
  var value = createAnimatedValue(isClicked);
  React.useEffect(function () {
    Animated.timing(value.current, {
      toValue: isClicked ? 1 : 0,
      duration: transitionTime
    }).start();
  }, [isClicked]);
  var isHovered = useHover(ref);
  var backgroundColor = isClicked ? "rgba(255,255,255," + (isHovered ? '0.3' : '0.4') + ")" : isHovered ? '#fff0bb' : '#fddf75';
  var borderColor = isClicked ? 'rgba(255,255,255,0.9)' : '#d6b05eb5';
  return React.createElement(Animated.View, _extends({}, props, {
    ref: ref,
    style: [styles.circle, {
      borderWidth: value.current.interpolate({
        inputRange: [0, 1],
        outputRange: [3, 2]
      }),
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      transform: [{
        translateX: value.current.interpolate({
          inputRange: [0, 1],
          outputRange: [sideOffset, width - circleWidth - sideOffset]
        })
      }]
    }, props.style]
  }), React.createElement(MoonIcon, {
    isClicked: isClicked
  }));
};

function webStyle(style) {
  return Platform.select({
    web: style,
    "default": {}
  });
}

var styles = StyleSheet.create({
  wrapper: _objectSpread({
    borderRadius: 17,
    overflow: 'hidden'
  }, webStyle({
    willChange: 'transform'
  })),
  dayNightSwitch: _objectSpread(_objectSpread({}, webStyle({
    cursor: 'pointer'
  })), {}, {
    flexDirection: 'row',
    alignItems: 'center',
    height: 35,
    width: width,
    borderRadius: 17
  }),
  star: {
    borderRadius: Platform.select({
      web: '100%',
      "default": 17
    }),
    backgroundColor: 'white',
    position: 'absolute'
  },
  circle: _objectSpread(_objectSpread({
    borderRadius: 17
  }, webStyle({
    cursor: 'pointer',
    borderRadius: '100%'
  })), {}, {
    width: circleWidth,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    height: 27,
    overflow: 'hidden',
    borderStyle: 'solid'
  }),
  moonSvg: _objectSpread(_objectSpread({}, webStyle({
    userSelect: 'none'
  })), {}, {
    position: 'absolute',
    width: 13,
    height: 13,
    opacity: 1
  })
});